/* eslint-disable @typescript-eslint/no-explicit-any */
import { DatePipe } from "@angular/common";
import { Component, inject, input, OnInit, output } from "@angular/core";
import { FaIconLibrary, FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslatePipe } from "@ngx-translate/core";

import { AdaaHelper } from "../../../../core/utils";
import { Constants } from "../../../constants/constants";
import { LanguageService } from "../../../services";
import { NoteComponent } from "../note/note";
import { CommentsEditorModalComponent } from "./comments-editor-modal/comments-editor-modal";

@Component({
  selector: "adaa-comments",
  imports: [TranslatePipe, FontAwesomeModule, NoteComponent, DatePipe],
  templateUrl: "./comments.html",
  styleUrl: "./comments.scss",
})
export class CommentsComponent implements OnInit {
  private _iconLibrary: FaIconLibrary = inject(FaIconLibrary);
  private _modalService = inject(NgbModal);
  private _languageService = inject(LanguageService);

  comments = input.required<any[] | undefined>();
  messageToken = input.required<string>();
  titleToken = input<string>("");
  dateToken = input<string>("");
  isLocalized = input<boolean>(true);
  showNumber = input<boolean>(false);
  cardTitle = input<string | undefined>(undefined);
  classes = input<string>("fw-bold");
  isEditable = input<boolean>(false);
  editCardTitle = input<string>("");
  noCommentsMessage = input<string>("");

  commentAdded = output<string>();
  commentRemoved = output<any>();

  constants = Constants;

  public ngOnInit(): void {
    this._iconLibrary.addIcons(faPlus);
  }

  public openAddModal(): void {
    const modal = this._modalService.open(CommentsEditorModalComponent, {
      centered: true,
      size: "xl",
      modalDialogClass: this._languageService.modalDirection(),
    });

    modal.componentInstance.cardTitle = this.editCardTitle();

    modal.result.then((e) => {
      if (!e) return;

      this.commentAdded.emit(e);
    });
  }

  public commentTitle(comment: any): string {
    return this._tokenValue(comment, this.titleToken());
  }

  public commentMessage(comment: any): string {
    return this._tokenValue(comment, this.messageToken());
  }

  public commentDate(comment: any): number | undefined {
    const token = this.dateToken();
    if (!token) return undefined;

    return comment[token];
  }

  private _tokenValue(comment: any, token: string): string {
    if (!token) return "";
    if (!this.isLocalized()) return comment[token] ?? "";

    return AdaaHelper.getItemValueByToken(comment, token, this._languageService.current());
  }
}
